export const homePageRowSetting = {
  vertical: {
    desktop: 40,
    tablet: 32,
    mobile: 32,
  },
  maxWidth: 1140,
};
